
import React, { Suspense, useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { styled } from '@mui/system';
import { MainViewInstruction, MainViewRX, changeMainView, mainViewPresenter$ } from '../../../globals/observables/main/mainViewObservable';
import AuthPresenter from '../../auth/authPresenter';
import LandingPresenter from '../../landing/landingPresenter';
import ErrorPresenter from '../../error/errorPresenter';
import { AuthSessionState } from '../../../globals/data/authSessionState';
import { AuthSessionRX, AuthSessionStatus, authSessionState$ } from '../../../globals/observables/IMAuthFlow/imAuthFlowObservable';
import { AuthSessionContext } from '../../../globals/context/authContext';
import { AIS_WORKER_VERSION } from '../../../globals/context/globalContext';


// const Workspace = React.lazy(() => import('../../workspace/workspacePresenter'));
// const ScratchPad = React.lazy(() => import('../../scratchPad/scratchPadPresenter'));




export const RootContainer = styled("div")(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    background-color: #595959;
    overflow: hidden;
    //flex-grow: 1;
    width: auto;
    flex-wrap: nowrap;
    //margin:2px;
    flex-grow: 1;
    `
);

export const RootContainerItem = styled("div")(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    //background-color: olive;
    overflow: hidden;
    //flex-grow: 1;
    //margin:2px;
    flex-basis: 100%;
    `
);



const GeneralButtonStyle = {
  display: "flex",
  flexDirection: "row",
  flexGrow: 1,
  color: "black",
  height: "35px",
  marginTop: "auto",
  marginBottom: "auto",
  width: "35px",
  backgroundColor: "gray",
  maxHeight: "35px !Important",
  maxWidth: "35px  !Important",
  minHeight: "35px !Important",
  minWidth: "35px  !Important",
  padding: "0px"
};


const WrapperContainer = styled("div")(
  ({ theme }) => `
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    //background-color: pink;
    flex-basis: 100%;
    `
);


function Presentation() {


  const [currentView, setCurrentView] = useState<MainViewRX>({} as MainViewRX)

  const [authSession, setAuthSession] = useState<AuthSessionRX>({} as AuthSessionRX);
  const [authState, setAuthState] = useState<AuthSessionState>({} as AuthSessionState);
  const [authSuccess, setAuthSuccess] = useState(false);

  useLayoutEffect(() => {
    const MainViewPresenter$ = mainViewPresenter$.subscribe(setCurrentView);
    const authSession$ = authSessionState$.subscribe(setAuthSession);



    return () => {
      MainViewPresenter$.unsubscribe();
      authSession$.unsubscribe();
    };
  }, [])


  // useEffect(() => {
  //   if (authSession === undefined) {
  //     return;
  //   }

  //   if (authSession.authSessionStatus === AuthSessionStatus.SUUCCESS) {

  //     setAuthState(authSession);
  //     setAuthSuccess(true);

  //     //Now we bump the view state to show the landing presenter
  //     //where we will determine what to show this user based on their
  //     //internal profile and roles
  //     changeMainView(MainViewInstruction.LANDING);

  //   }

  // }, [authSession]);


  //Dev only
  useEffect(() => {

      //Now we bump the view state to show the landing presenter
      //where we will determine what to show this user based on their
      //internal profile and roles
      changeMainView(MainViewInstruction.LANDING);


  }, []);


  return (

    <AIS_WORKER_VERSION.Provider value="1.0.0">
      <AuthSessionContext.Provider value={authState}>
        <RootContainer id="RootContainer">
          <RootContainerItem id="RootContainerItem">

            <WrapperContainer id='wrapperContainer'>

              {
                (currentView.mainViewInstruction === MainViewInstruction.AUTH)
                  ?
                  <AuthPresenter />

                  : (currentView.mainViewInstruction === MainViewInstruction.LANDING)
                    ?
                    <LandingPresenter />

                    : (currentView.mainViewInstruction === MainViewInstruction.ERROR)
                    ?? <ErrorPresenter />
              }


            </WrapperContainer>
          </RootContainerItem>
        </RootContainer>

      </AuthSessionContext.Provider>
    </AIS_WORKER_VERSION.Provider>

  );
};


export default Presentation;